import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Component } from "react";

type StateType = {
  hasError: boolean;
  message: string | null;
  hideButton: boolean;
};
class ErrorBoundary extends Component<
  { children: React.ReactNode },
  StateType
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = {
      hasError: false,
      message: null,
      hideButton:
        window.location.href.includes("/externo/") ||
        window.location.href.includes("/public/"),
    };
  }

  componentDidCatch(error: Error) {
    if (error.name === "CustomError") {
      this.setState((oldState) => ({
        ...oldState,
        message: error.message,
      }));
    }
  }

  static getDerivedStateFromError(_: Error) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="h-screen flex items-center -mt-10">
          <div className="w-full">
            <div className="max-w-sm m-auto flex flex-col items-center gap-6">
              <FontAwesomeIcon icon="robot" className="text-6xl" />

              <div className="uppercase font-mono tracking-tighter">Erro</div>

              {this.state.message && (
                <div className="mx-4 bg-gray-100 border border-gray-400 rounded-lg font-mono text-xs text-gray-700 leading-5 p-3">
                  {this.state.message}
                </div>
              )}

              {!this.state.hideButton && (
                <a
                  className="border rounded py-2 px-4 font-bold hover:bg-slate-50 flex gap-2 items-center"
                  href="/"
                >
                  <FontAwesomeIcon icon="house" />
                  <span>Voltar para o início</span>
                </a>
              )}
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
